import React from 'react';
import { Divider } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Price } from '@partsbadger/library';

interface IQuotePricingSummaryProps {
    subTotalQuote: number;
    taxTotalQuote: number;
    grandTotalQuote: number;
    completePartsLength: number;
}

const QuotePricingSummary: React.FC<IQuotePricingSummaryProps> = ({
    subTotalQuote,
    taxTotalQuote,
    grandTotalQuote,
    completePartsLength,
}) => {
    return (
        <div data-testid="quote-pricing-summary" className="space-y-4">
            <h4 data-testid="quote-pricing-summary-heading" className="font-medium text-slate-900">Pricing Summary</h4>

            <div className="space-y-2">
                <div data-testid="quote-pricing-summary-subtotal" className="flex justify-between text-sm">
                    <span className="text-slate-600">Subtotal</span>
                    <span className="font-medium text-slate-900">
                        <Price value={subTotalQuote ?? 0} />
                    </span>
                </div>
                <div className="flex justify-between text-sm">
                    <span className="text-slate-600">Tax Estimate by Zip Code</span>
                    <span className="font-medium text-slate-900">
                        <Price value={taxTotalQuote ?? 0} />
                    </span>
                </div>

                <Divider />

                <div data-testid="quote-pricing-summary-total" className="flex justify-between">
                    <span className="text-lg font-semibold text-slate-900">Total</span>
                    <span className="text-2xl font-bold ">
                        <Price value={grandTotalQuote ?? 0} />
                    </span>
                </div>

                <p className="text-[12px]  text-right">
                    Shipping & handling and exact taxes will be calculated at checkout
                </p>
            </div>

            {completePartsLength === 0 && (
                <div className="text-center py-4">
                    <p className="text-sm text-slate-500 flex items-center justify-center space-x-1">
                        <InfoCircleOutlined className="w-4 h-4" />
                        <span>Configure parts to see pricing</span>
                    </p>
                </div>
            )}
        </div>
    );
};

export default QuotePricingSummary;
